import chardet from 'chardet';

export class DynamicEncodingFileReader extends FileReader {

	private MINIMUM_CONFIDENCE = 50;

	constructor() {
		super();
	}

	/**
	 * Dynamically determines encoding to use for reading the file. If an encoding is passed it will use that passed encoding.
	 */
	async readAsText(blob: Blob, encoding?: string | undefined) {
		if (encoding) {
			super.readAsText(blob, encoding);
		}

		const dynamicallyDeterminedEncoding = await this.getEncoding(blob);

		if (dynamicallyDeterminedEncoding) {
			// This will use default (utf-8) if the encoding is not supported
			super.readAsText(blob, dynamicallyDeterminedEncoding);
		} else {
			super.readAsText(blob);
		}
	}

	private async getEncoding(blob: Blob) {
		const arrayBuffer = await blob.arrayBuffer();
		const uint8Array = new Uint8Array(arrayBuffer);

		try {
			// This will be an array of encoding guesses, ordered by descending confidance
			const encodingAnalysis = chardet.analyse(uint8Array);
			if (encodingAnalysis[0] && encodingAnalysis[0].confidence > this.MINIMUM_CONFIDENCE) {
				return encodingAnalysis[0].name;
			}
		} catch (err) {
			console.error('Error detecting encoding, using default...');
		}

		return null;
	}
}
